import { Component, OnInit } from '@angular/core';
import { RouterOutlet, RouterLink, Router, NavigationEnd } from '@angular/router';
import { CollegeAdminWelcomeComponent } from './welcome/welcome.component';
import { ResetPassDialogComponent } from '../authentication/reset-pass-dialog/reset-pass-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { combineLatest, filter, map, Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';
import { AuthUser, SubscriptionAlerts } from '../store/Authentication/auth.models';

@Component({
  selector: 'app-college-admin-dashbaord',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
  ],
  templateUrl: './college-admin-dashbaord.component.html',
  styleUrl: './college-admin-dashbaord.component.scss'
})
export class CollegeAdminDashbaordComponent implements OnInit {
  private destroy$ = new Subject<void>();
  showWarning = false
  excludedRoutes = [
    '/college-admin-dashboard/welcome',
    '/college-admin-dashboard/subscription',
    '/college-admin-dashboard/subscription?tab=payment-methods',
    '/college-admin-dashboard/subscription?tab=subscription-config',
    '/college-admin-dashboard/subscription?tab=overview',
    '/college-admin-dashboard/payment-billing',
    '/college-admin-dashboard/invoices'
  ];
  user$ = this.authService.loggedInUser$
  constructor(private dialog: MatDialog, private router: Router, private authService: AuthenticationService) {

  }

  ngOnInit(): void {
    this.checkPassword()
    const route$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
    );

    combineLatest([route$, this.user$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([url, user]) => {
        const isExcludedRoute = this.excludedRoutes.includes(url);
        const hasAlert = user?.subscription?.alerts?.showPaymentFailed;
        console.log("User: ", user)
        this.showWarning = !!hasAlert && !isExcludedRoute;
      });
    if (this.user$) {
    }
  }

  private checkPassword() {
    this.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        if (user?.shouldRenewPassword) {
          this.onPassChange();
        }
      });
  }
  private onPassChange() {
    const dialogConfig = this.dialog.open(ResetPassDialogComponent, {
      minWidth: "650px",
      width: "800px",
      maxHeight: "90vh",
      disableClose: true,
    });
    dialogConfig.afterClosed().subscribe((results) => {
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}











